/* eslint-disable @calm/react-intl/missing-formatted-message */
import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import React from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';

const Heading = styled.p`
  font-weight: var(--font-weight-bold);
  margin-top: 80px;
  margin-bottom: 1rem;
  font-size: 16px;
  line-height: 22px;
`;

const Description = styled.p`
  margin-top: 1rem;
`;

export const HAuthenticate = () => {
  return (
    <div style={{ marginLeft: '80px' }}>
      <Heading>Connect to Hubspot</Heading>
      <Button icon={ArrowRight16} iconPlacement="right" type="primary">
        Log in
      </Button>
      <Description className="caption-01">Description goes here</Description>
    </div>
  );
};
